<template>
  <div class="logos">
    <a href="http://sydney.edu.au/perkins/" target="_blank">
      <img src="./img/USydney.png" alt="University of Sydney" title="University of Sydney" />
    </a>
    <a href="https://www.garvan.org.au/" target="_blank">
      <img src="./img/Garvan.png" alt="Garvan Institute" title="Garvan Institute" />
    </a>
  </div>
</template>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
img {
  height: clamp(20px, 8vw, 55px);
  width: auto;
  vertical-align: text-top;
}
</style>
